"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvisioningRecord = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Device.Manufacturing';
exports.ProvisioningRecord = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    manufacturingSerialNumber: effect_1.Schema.String,
    dsn: effect_1.Schema.NullOr(effect_1.Schema.String),
    assetTag: effect_1.Schema.NullOr(effect_1.Schema.String),
    sku: effect_1.Schema.NullOr(effect_1.Schema.String),
    fw: effect_1.Schema.NullOr(effect_1.Schema.String),
    factoryName: effect_1.Schema.NullOr(effect_1.Schema.String),
    manufacturedAt: effect_1.Schema.String,
    publicIpAddress: effect_1.Schema.NullOr(effect_1.Schema.String),
}).annotations({ identifier: `${exports.NAMESPACE}.ProvisioningRecord` });
//# sourceMappingURL=manufacturing.js.map